import { Routes, Route } from 'react-router-dom';
import DataPusher from './DataPusher/DataPusher';
import ToolSelector from './ToolSelector';

const ToolsRouter = () => {
    return (
        <Routes>
            <Route index element={<ToolSelector />} />
            <Route path="data-pusher" element={<DataPusher />} />
        </Routes>
    );
};

export default ToolsRouter;
